module.exports = __webpack_public_path__ + "static/media/empty_offers.fb223eb6.png";